import React, { useEffect, useState } from 'react'
import { ProgressBar } from 'react-bootstrap'
import { SIZES } from '../../styles/theme'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import startQuiz from '../../images/mobile/mobile-start-quiz.png'
import back from '../../images/booth/back_icon.png'
import next from '../../images/booth/next_arrow.png'
import prev from '../../images/booth/prev_arrow.png'
import complete from '../../images/booth/check.png'
import { KioskPoster } from './KioskPoster'
import { useDispatch, useSelector } from 'react-redux';
import { submitAnswer, appendAnswers, resetAnswers } from 'src/ducks/booth';
import LoadIcon from '../LoadIcon';
import Amplitude from 'src/utils/amplitudeHelper'

const Wrapper = styled.div`
  padding: 20px 0;
  font-size: 12px;
  border-bottom: solid 3px #c69dff;
  width: 100%;

  .kiosk-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    .back-button {
      cursor: pointer;
      img {
        height: 8px;
      }
      small {
        margin: 0 8px;
        font-weight: 500;
      }
    }
  }
  .booth-kiosk-item-icon {
    height: 40px;
  }

  .booth-kiosk-item-label {
    font-size: 17px;
    width: 100%;
    color: #492379;
    margin: 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    p {
      color: #3A2D86;
      margin: 0;
      font-size: 14px;
    }
  }
  
  .kiosk-question {
    padding-top: 20px;
    .navigate {
      text-align: right;
      img {
        width: 10%;
      }
    }
  }
  .status {
    align-self: center;
    small {
      text-align: right;
      color: #305F72;
      font-size: 0.85em;
      letter-spacing: -1px;
    }
  }
  .progress {
    background-color: #B6F7F2;
    border-radius: 10px;
    height: 8px;
  }
  .progress-bar {
    background-color: #26B4A9;
  }
  .stats {
    text-decoration: underline;
    color: #26B4A9;
    font-size: 14px;
    margin-left: 12px;
    cursor: pointer;
    font-weight: 400;
  }
  .message-container {
    text-align: center;
    font-weight: 600;
    color: #3A2D86;
    img {
      width: 25%;
    }
    .screen-title {
      font-size: 16px;
      margin-bottom: 12px;
    }
    .result {
      font-size: 18px;
      margin-bottom: 0;
    }
  }
`
const ChoiceItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  .check-bullet {
    margin-right: 8px;
    border-radius: 50%;
    background-color: white;
    border: 2px solid #3A2D86;
    .bullet {
      height: 10px;
      border-radius: 50%;
      padding: 6px;
      background-color: ${(props) => props.selected ? '#26B4A9' :'white'};
    }
    .show-correct {
      background-color: red;
    }
  }
  .choice-text {
    color: #3C3C3C;
    font-size: 14px;
    margin: 4px 0;
  }
  ${SIZES.mobile} {
    align-items: flex-start;
    .check-bullet {
      margin-right: 12px;
      margin-top: 2px;
    }
    .choice-text {
      margin: 0;
      margin-bottom: 8px;
    }
  }
`


export default function MobileKioskSection({ quiz, kioskSection, setKioskSection, isFinishScreen, setIsFinishScreen }) {
  const dispatch = useDispatch()
  const { viewBooth, boothQuizAnswers, userScore, submitting } = useSelector((state) => state.booth)
  const [currentLesson, setCurrentLesson] = useState(0)
  const [answer, setAnswer] = useState('')
  const [kioskPoster, setKioskPoster] = useState(false)
  const [answerList, setAnswerList] = useState([]) 
  const [numberOfCorrect, setNumberOfCorrect] = useState(0)

  const lesson = quiz[currentLesson] || {question:"",choices:[]}

  const tips = [
    'His name has the most alphabet "A"',
    "Above 4 million.",
    "You should know this.",
    "The more the merrier.",
    "What do you think?",
  ]

  useEffect(() => {
    if (kioskSection) {
      if (boothQuizAnswers[viewBooth.id] && boothQuizAnswers[viewBooth.id]?.length > 0) {
        setAnswerList(boothQuizAnswers[viewBooth.id])
        dispatch(resetAnswers(viewBooth.id))
      }
      setCurrentLesson(0)
      setIsFinishScreen(userScore === 5)
    }
  }, [kioskSection])

  useEffect(() => {
    if (currentLesson === quiz.questionCount && quiz.questionCount !== 0) {
      const numberCorrect = boothQuizAnswers[viewBooth.id].filter(item=>item.isCorrect === true).length
      setNumberOfCorrect(numberCorrect)
      if (numberCorrect === quiz.questionCount) {
        const payload = {
          question_ids : boothQuizAnswers[viewBooth.id].map(item=>item.id),
          answer_indexes : boothQuizAnswers[viewBooth.id].map(item=>item.answer)
        }
        Amplitude.submitQuiz()
        dispatch(submitAnswer(viewBooth.id, payload))
      }
      setIsFinishScreen(true)
      setKioskSection(false)
      setAnswerList([])
      dispatch(resetAnswers(viewBooth.id))
    }
    else {
      const foundAnswer = answerList.filter(item=>item.id===quiz[currentLesson].id)
      setAnswer(foundAnswer.length > 0 ? foundAnswer[0].answer : '')
    }
  }, [currentLesson])


  const closeKioskPoster = () => {
    setKioskPoster(false)
    toggleKioskSection()
  }

  const toggleKioskSection =() => {
    Amplitude.clickQuizKiosk()
    if (isFinishScreen) {
      setIsFinishScreen(!isFinishScreen)
      setCurrentLesson(0)
      setAnswer('')
    } 
    setKioskSection(!kioskSection)
  }
  const answerQuestion = (index) => {
    setAnswer(index)
  }
  const onClickBtn = (btn) => {
    if (btn === "next"){ 
      if(answer === ''){
        toast("Please select an answer.")
      }else{
        let newList;
        if (answerList.filter(item=>item.id===quiz[currentLesson].id).length > 0){
          newList = answerList.map(item=>{
            if (item.id===quiz[currentLesson].id){
              return { id: item.id, answer: answer, isCorrect: quiz[currentLesson].answer_index === answer}
            } else {
              return item
            }
          })
        } else {
          newList = [
            ...answerList,
            { id: quiz[currentLesson].id, answer: answer, isCorrect: quiz[currentLesson].answer_index === answer}
          ]
        }
        setAnswerList(newList)
        dispatch(appendAnswers(viewBooth.id, newList))
        setCurrentLesson(currentLesson + 1)
      }
    }
    if (btn === "prev") setCurrentLesson(currentLesson - 1)
  }

  return (
    <Wrapper>
      <div className="booth-kiosk-item-label">
        <div className="w-100">
          <div className="kiosk-header">
            <strong className="d-flex align-items-end">
              <span>Hyruan ONE Quiz</span>
            </strong> 
            { (kioskSection || isFinishScreen)  && 
              <strong className="back-button" onClick={toggleKioskSection}>
                <img src={back} alt="back"/>
                <small>{kioskSection ? 'Quit' : 'Back'}</small>
              </strong>
            }
          </div>
          { (!kioskSection && !isFinishScreen) ? 
            <p>Spare 3 mins to answer this quiz</p> 
            :
            (kioskSection && !isFinishScreen) ?
            <div className="d-flex justify-content-between w-100">
              <div className="status" style={{width: '60%'}}>
                <ProgressBar variant="default" now={(currentLesson+1)/quiz.questionCount * 100} />
              </div>
              <div className="status">
                <small>Question {currentLesson+1 > quiz.questionCount ? quiz.questionCount : currentLesson+1} out of {quiz.questionCount}</small>
              </div>
            </div>
            :
            null
          }
        </div>
        { (!kioskSection && !isFinishScreen) && <img src={startQuiz} className="booth-kiosk-item-icon" alt="chat-icon" onClick={() => setKioskPoster(true)}/>}
      </div>
      {isFinishScreen ?
        <div className="message-container my-3">
          <p className="screen-title">Thank You For Your Participation!</p>
          {submitting ? <LoadIcon spinnerColor="#002060" /> :
            userScore === quiz.questionCount ?
            <>
              <img src={complete} alt="complete tick"/>
              <div>
                <p className="result">You score {userScore} out of {quiz.questionCount}!</p>
              </div>
            </>
            :
            <div>
              <p className="result">You score {numberOfCorrect} out of {quiz.questionCount}!</p>
              <p className="result">Don't give up, try again!</p>
            </div>
          }
        </div> :
        kioskSection &&
        <div className="kiosk-question">
          <p className="question-text m-0">{lesson.title}</p>
          <p><small className="text-muted font-italic">Tips: {tips[currentLesson]}</small></p>
          {lesson.choices.map((option, index)=>(
            <ChoiceItem key={option} onClick={()=>answerQuestion(index)} selected={index === answer}>
              <div className="check-bullet">
                <div className="bullet"></div>
              </div>
              <p className="choice-text">{option}</p>
            </ChoiceItem>
          ))}
          <div className="navigate">
            { currentLesson > 0 && <img id="prev-button" src={prev} alt="prev icon" onClick={()=>onClickBtn('prev')} />}
            { currentLesson !== quiz.questionCount && <img id="next-button" src={next} alt="next icon" onClick={()=>onClickBtn('next')} />}
          </div>
        </div>
      }
      { kioskPoster && <KioskPoster showPoster={closeKioskPoster} showModal={closeKioskPoster} />}
    </Wrapper>
  )

}
